import { useContext } from 'react';
import { makeStyles, Button, Container } from '@material-ui/core';
import { CircleLoader, Page } from 'components';
import { useLocation } from 'react-router';
import { Formik, Form } from 'formik';
import { Save as SaveIcon } from '@material-ui/icons';
import { adminUserContext } from './AdminUserContext';
import { UserForm } from './components';


let useStyles = makeStyles(theme => ({
    button: {
        marginTop: 16,
        float: "right"
    }
}));

let AdminUsers = () => {
    let classes = useStyles();
    let location = useLocation();

    let isNew = location.pathname.includes("addnew");

    let service = useContext(adminUserContext);


    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title={isNew ? 'Add user' : 'Edit user'}
                isLoading={service.isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    initialValues={service.user}
                    validationSchema={service.userSchema}
                    onSubmit={async (values, action) => {
                        action.setSubmitting(true);
                        await service.saveUser(values);
                    }}
                >
                    <Form>
                        {service.isLoading && <CircleLoader />}
                        {service.isLoading === false &&
                            <UserForm isNew={isNew} />
                        }
                        <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            <SaveIcon />&nbsp; Save
                        </Button>
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default AdminUsers;